<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :hot-key-create-path="`/user/create`"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
  >
    <template #headerContent>
      <GcHeaderContentStatic title="Users" />
    </template>

    <div>
      <gc-filter-split-view
        :showLeftContainer="showFilterLeftContainer"
        :showRightContainer="showFilterRightContainer"
      >
        <template #leftContent>
          <dx-data-grid
            :data-source="dataSourceConfig"
            :columns="columns"
            @selection-changed="onSelectionChanged($event, rowSelect)"
            @toolbar-preparing="onToolbarPreparing($event)"
            :height="gridHeight"
            @content-ready="addGridNoResults($event)"
          >
            <template #active-cell-template="{ data }">
              <GcInactive :inactive="data.data.Inactive" />
            </template>
          </dx-data-grid>
        </template>
        <template #rightContent>
          <gc-advance-filter-panel
            :toolbar="filterToolbar"
            :setFilterFormHeight="filterFormHeight"
            :sideBarTabs="sideBarTabs"
            :filterFormItems="filterFormItems"
            :filterModel="getAdvanceFilterModel"
            :isJson="false"
            :screenType="'supplier-contact-list'"
            :data-source-config="dataSourceConfig"
          >
          </gc-advance-filter-panel>
        </template>
      </gc-filter-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../../v1/_mixins/base.view";
import { UserService } from "../../../_services/api/settings/user/user.service";

export default {
  props: {},
  mixins: [BaseViewMixin],
  components: { },
  data() {
    return {
      pageSizes: [5, 10, 20],
      rowSelect: {
        view: this,
        page: "user",
        mode: "review",
        idProperty: "ApplicationUserCode",
      },
    };
  },
  methods: {
    backButtonFunction() {
      this.$router.push({
        path: "/settings/user",
      });
    },
    advanceFilterModel: {
      Inactive: "",
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "searchPanel" && item.name !== "columnChooserButton"
        );
      });

      searchPanel.location = "after";

      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxButton",
          options: {
            icon: "plus",
            text: "Add New",
            onClick: () => {
              this.$logger.trackEventButtonClickAddNew();
              this.$router.push({
                path: "/user/create",
              });
            },
          },
        },
        searchPanel,
        columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.showFilterRightContainer = !this.showFilterRightContainer;
              var item = document.getElementById("filter-btn");
              this.$logger.debug("item ", item);
              item.classList.add("dx-state-invisible");
            },
          },
        }
      );
    },
  },
  computed: {
    columns() {
      return this.parseGridColumns("transaction", [
        {
          gcLabel: "User",
          dataField: "ApplicationUserCode",
          gcType: "String",
          gcSubType: "PrimaryRecord",
        },
        {
          gcLabel: "User Type",
          dataField: "ApplicationUserTypeCode",
          gcType: "String",
          width: 150,
        },
        {
          gcLabel: "Active",
          gcType: "String",
          gcSubType: "Chip",
          dataField: "Inactive",
          cellTemplate: "active-cell-template",
        },
      ]);
    },
    getAdvanceFilterModel() {
      return this.advanceFilterModel;
    },
    filterFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: this.parseFormColumns([
            {
              dataField: "Inactive",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Status",
              editorOptions: {
                items: [
                  {
                    text: "Active",
                    value: "N",
                  },
                  {
                    text: "Inactive",
                    value: "Y",
                  },
                ],
                valueExpr: "value",
                displayExpr: "text",
              },
            },
          ]),
        },
      ];
    },
    dataSourceConfig() {
      return UserService.dataSourceConfig({
        url: "api/ApplicationUserToApplicationTenant",
        select: ["ApplicationUserCode", "ApplicationUserTypeCode", "Inactive"],
        orderby: "ApplicationUserCode asc",
        sort: [{ selector: "ApplicationUserCode", desc: false }],
        top: "50",
        count: true,
      });
    },
  },
};
</script>
